import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Assigns and unassigns Routing Profiles to a Vehicle Group
 * @param vehicleGroupId The ID of the Vehicle Group who the Routing Profiles are being assigned to
 * @param assignmentRoutingProfileIds The IDs of the Routing Profiles being assigned
 * @param unassignmentRoutingProfileIds The IDs of the Routing Profilesbeing unassigned
 */
export function postVehicleGroupsRoutingProfilesCombinedAssignment(
  this: unknown,
  vehicleGroupId: number,
  assignmentRoutingProfileIds: number[],
  unassignmentRoutingProfileIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsIdRoutingProfilesCombinedAssignmentUrl(
            String(vehicleGroupId)
          ),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentRoutingProfileIds,
            unassignmentRoutingProfileIds,
          }),
        }
      )
    )
  ).pipe(ignoreData());
}
